import * as React from 'react';
import { Label } from '@atlaskit/form';
import { FieldDescription } from './field-description';
import { ErrorText, FieldContainer, RequiredContainer } from './styled';

interface FieldBaseProps {
    label: string;
    htmlFor: string;
    errorMessage?: React.ReactNode;
    description?: string | React.ReactNode;
    required?: boolean;
    children?: React.ReactNode;
    noLabel?: boolean;
}

const FieldBase: React.FC<FieldBaseProps> = ({
    label,
    required,
    errorMessage,
    description,
    children,
    noLabel,
    htmlFor,
}) => {
    const renderField = () =>
        noLabel ? (
            children
        ) : (
            <>
                {/* The old label had a margingTop of 20px but Field has marginTop of 8px hence this FieldContainer is required */}
                <FieldContainer>
                    <Label htmlFor={htmlFor}>
                        {label}
                        {required && <RequiredContainer aria-hidden="true">*</RequiredContainer>}
                    </Label>
                </FieldContainer>
                {children}
            </>
        );

    return (
        <div data-test-id={`request-field-${htmlFor}`}>
            {renderField()}
            {!!errorMessage && <ErrorText data-test-id="field-error">{errorMessage}</ErrorText>}
            {description && <FieldDescription>{description}</FieldDescription>}
        </div>
    );
};

export default FieldBase;
